import { GenericError } from '@/models/generic-error';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { GamesQueryKeys } from '../../queryKeys';

import { GameWinProbabilityInputDto } from '@/services/dto/games/game-win-probability-input.dto';
import { Decimal } from '@starsoft/common/services/Decimal';
import {
  UseGameWinProbabilityProps,
  UseGameWinProbabilityQueryKey,
} from './props';
import { fetchGameWinProbability } from './service';

export function useGameWinProbability(options?: UseGameWinProbabilityProps) {
  const {
    enabled = true,
    gameId,
    crashpoint,
    refetchOnMount = true,
  } = options ?? {};

  const params: GameWinProbabilityInputDto = {
    gameId,
    crashpoint,
  };
  const queryKey: UseGameWinProbabilityQueryKey = [
    GamesQueryKeys.WinProbability,
    params,
  ];

  const { data, fetchStatus, ...infinityQuery } = useQuery<
    Decimal,
    AxiosError<GenericError>,
    Decimal,
    UseGameWinProbabilityQueryKey
  >({
    queryKey,
    queryFn: fetchGameWinProbability,
    enabled,
    staleTime: 5 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount,
  });

  return {
    ...infinityQuery,
    winProbability: data,
    isLoading: infinityQuery.isPending && fetchStatus !== 'idle',
    error: infinityQuery.error as AxiosError<GenericError>,
  };
}
